import React, { useEffect, useState } from "react";
import dayjs from "dayjs";

import { Button, Col, Row, Typography } from "antd";
import SearchInput from "../../../components/Input/SearchInputs/SearchInput";
import { DownloadOutlined, LoadingOutlined, SyncOutlined } from "@ant-design/icons";

// import { ReactComponent as DefaultIcon } from "../../../assets/icons/default.svg";
import DateRangePicker from "../../../components/DateRangePicker/DateRangePicker";
import CustomSelect from "../../../components/SelectableDropdown/CustomSelect/CustomSelect";
import CustomTableWithPagination from "../../../components/CustomTableWithPagination/CustomTableWithPagination";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";
import NoDataFound from "../../../components/EmptyTable/NoDataFound";
import {  
  dateFormat,
} from "../../../commonFuntions/CommonUtilFunctions";
import { useLazyGetHSNReportQuery,useLazyGetHSNDownloadReportQuery ,useSyncHSNReportMutation} from "../../../apis/reports";
// import { getNameInitials } from "../../../commonFuntions/CommonUtilFunctions";
// import { useLazyGetLineofCreditExcelQuery } from "../../../apis/forms";
// import { handlePdfDownload } from "../../../commonFuntions/CommonUtilFunctions";
import { showErrorToast, showSuccessToast } from "../../../NotificationToast/NotificationToast";
import { apiBaseUrl } from "../../../commonUtils/commonUtils";
const { Text } = Typography;

const getReportDownloadUrl = (url) => {
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  return `${apiBaseUrl}${url.startsWith("/") ? "" : "/"}${url}`;
};

const getReportFileName = (url, fallbackName) => {
  try {
    return decodeURIComponent(new URL(url).pathname.split("/").pop()) || fallbackName;
  } catch (error) {
    return url?.split("?")[0]?.split("/").pop() || fallbackName;
  }
};

const downloadReportFile = (url, fileName) => {
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.target = "_blank";
  link.rel = "noopener noreferrer";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const HSNReport = () => {
  const [searchedValue, setSearchedValue] = useState({});
  const [dateFilter, setDateFilter] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [dateSearch, setDateSearch] = useState({
    start_date: "",
    end_date: "",
  });

  

  const [getHSNReportApi, { data: hsnData, isFetching: isLoading }] =
    useLazyGetHSNReportQuery();    
    const [excelApi, { isFetching: isExporting }] =
      useLazyGetHSNDownloadReportQuery();
    const [syncHSNReportApi, { isLoading: isSyncingReport }] = useSyncHSNReportMutation();

  useEffect(() => {
    getHSNReportApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (value) => {
    let formattedDate = null;

    switch (value) {
      case "Today":
        formattedDate = dayjs().format("YYYY-MM-DD");
        break;
      case "Yesterday":
        formattedDate = dayjs().subtract(1, "day").format("YYYY-MM-DD");
        break;
      case "last_7_day":
        formattedDate = dayjs().subtract(6, "day").format("YYYY-MM-DD");
        break;
      case "last_30_day":
        formattedDate = dayjs().subtract(29, "day").format("YYYY-MM-DD");
        break;
      case "last_60_day":
        formattedDate = dayjs().subtract(59, "day").format("YYYY-MM-DD");
        break;
      case "Custom":
        formattedDate = "Custom";
        break;
      default:
        break;
    }

    const currentDate = dayjs().format("YYYY-MM-DD");
    if (value !== "Custom" && value !== null) {
      if (value === "clear_date") {
        getHSNReportApi({
          ...(searchedValue?.search && { search: searchedValue?.search }),
          page: 1,
        });
        setDateSearch({
          start_date: "",
          end_date: "",
        });
      } else {
        getHSNReportApi({
          start_date: formattedDate,
          end_date: currentDate,
          ...(searchedValue?.search && { search: searchedValue?.search }),
          page: 1,
        });
        setDateSearch({
          start_date: formattedDate,
          end_date: currentDate,
        });
      }

      setCurrentPage(1);
    }
    setDateFilter(value);
  };

  const handleChangeRangePicker = (dates, dateStrings) => {
    if (dates && dates?.length === 2) {
      const startDateFormatted = dates[0].format("YYYY-MM-DD");
      const endDateFormatted = dates[1].format("YYYY-MM-DD");
      getHSNReportApi({
        start_date: startDateFormatted,
        end_date: endDateFormatted,
        ...(searchedValue?.search && { search: searchedValue?.search }),
        page: 1,
      });
      setDateSearch({
        start_date: startDateFormatted,
        end_date: endDateFormatted,
      });
      setCurrentPage(1);
    }
  };
  const handleSearchedValue = (params) => {
    setSearchedValue(params);
    setCurrentPage(1);
  };
  const handlePageChange = async (currPage) => {
    const params = {
      page: currPage,
      ...(searchedValue && { search: searchedValue?.search }),
    };
    setCurrentPage(currPage);
    await getHSNReportApi(params);
  };
    const handleExportApi = async () => {
      let response = await excelApi({
        ...(searchedValue.search && { search: searchedValue.search }),
        ...(dateSearch.start_date && { start_date: dateSearch.start_date }),
        ...(dateSearch.end_date && { end_date: dateSearch.end_date }),
      });

      if (response?.error) {
        showErrorToast(response?.error?.data?.message || "Failed to download HSN report");
        return;
      }

      if (response?.status === "fulfilled") {
        const downloadUrl = getReportDownloadUrl(
          response?.data?.data?.url || response?.data?.data?.download_url
        );

        if (!downloadUrl) {
          showErrorToast("Download URL not found");
          return;
        }

        downloadReportFile(
          downloadUrl,
          getReportFileName(downloadUrl, "HSN-ORDER-SUMMARY.xlsx")
        );
      }

      // excelApi();
    };
  const handleSyncReport = async () => {
    try {
      const response = await syncHSNReportApi().unwrap();      
      showSuccessToast(response?.message || "HSN report synced successfully");
      await getHSNReportApi({
        ...(searchedValue?.search && { search: searchedValue?.search }),
        ...(dateSearch?.start_date && { start_date: dateSearch?.start_date }),
        ...(dateSearch?.end_date && { end_date: dateSearch?.end_date }),
        page: currentPage,
      });
    } catch (error) {
      showErrorToast(error?.data?.message || "Failed to sync HSN report");
    }
  };
  const options = [
    {
      key: 1,
      value: "Today",
      label: "Today",
    },
    {
      key: 2,
      value: "Yesterday",
      label: "Yesterday",
    },
    {
      key: 3,
      value: "last_7_day",
      label: "Last 7 day",
    },
    {
      key: 4,
      value: "last_30_day",
      label: "Last 30 day",
    },
    {
      key: 5,
      value: "last_60_day",
      label: "Last 60 day",
    },
    {
      key: 6,
      value: "Custom",
      label: "Custom",
    },
    {
      key: 7,
      value: "clear_date",
      label: (
        <Col style={{ color: "#006644", fontWeight: "500" }}>Clear Date</Col>
      ),
    },
  ];

  const formatAmount = (value) => {
    if (value === null || value === undefined) return "-";
    return `₹ ${Number(value).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const columns = [
    { title: "HSN Code", dataIndex: "hsn_code", key: "hsn_code", width: 140, fixed: "left" },
    {
      title: "GST Rates",
      dataIndex: "gst_rates",
      key: "gst_rates",
      width: 120,
      render: (value) => (Array.isArray(value) ? value.join(", ") : "-"),
    },
    { title: "Order Count", dataIndex: "total_order_count", key: "total_order_count", width: 120 },
    { title: "Suborder Count", dataIndex: "total_suborder_count", key: "total_suborder_count", width: 130 },
    { title: "Order Item Count", dataIndex: "total_order_item_count", key: "total_order_item_count", width: 140 },
    { title: "Product Count", dataIndex: "total_product_count", key: "total_product_count", width: 120 },
    { title: "Vendor Count", dataIndex: "total_vendor_count", key: "total_vendor_count", width: 120 },
    { title: "Customer Count", dataIndex: "total_customer_count", key: "total_customer_count", width: 130 },
    { title: "Total Quantity", dataIndex: "total_quantity", key: "total_quantity", width: 120 },
    {
      title: "Order Amount Without Tax",
      dataIndex: "total_order_amount_without_tax",
      key: "total_order_amount_without_tax",
      width: 200,
      render: formatAmount,
    },
    { title: "Tax Amount", dataIndex: "total_tax_amount", key: "total_tax_amount", width: 140, render: formatAmount },
    {
      title: "Order Amount With Tax",
      dataIndex: "total_order_amount_with_tax",
      key: "total_order_amount_with_tax",
      width: 180,
      render: formatAmount,
    },
    {
      title: "Vendor Paid Amount Without Tax",
      dataIndex: "total_vendor_paid_amount_without_tax",
      key: "total_vendor_paid_amount_without_tax",
      width: 230,
      render: formatAmount,
    },
    { title: "Vendor Paid Tax", dataIndex: "total_vendor_paid_tax", key: "total_vendor_paid_tax", width: 150, render: formatAmount },
    {
      title: "Vendor Paid Amount With Tax",
      dataIndex: "total_vendor_paid_amount_with_tax",
      key: "total_vendor_paid_amount_with_tax",
      width: 220,
      render: formatAmount,
    },
    {
      title: "MOB Profit Without Tax",
      dataIndex: "total_mob_profit_without_tax",
      key: "total_mob_profit_without_tax",
      width: 190,
      render: formatAmount,
    },
    {
      title: "MOB Profit With Tax",
      dataIndex: "total_mob_profit_with_tax",
      key: "total_mob_profit_with_tax",
      width: 170,
      render: formatAmount,
    },
    { title: "Settlement Count", dataIndex: "total_settlement_count", key: "total_settlement_count", width: 130 },
    {
      title: "First Order At",
      dataIndex: "first_order_at",
      key: "first_order_at",
      width: 170,
      render: (params) => <Text>{params ? dateFormat(params) : "N/A"}</Text>,
    },
    {
      title: "Last Order At",
      dataIndex: "last_order_at",
      key: "last_order_at",
      width: 170,
      render: (params) => <Text>{params ? dateFormat(params) : "N/A"}</Text>,
    },
    {
      title: "Last Synced At",
      dataIndex: "last_synced_at",
      key: "last_synced_at",
      width: 170,
      render: (params) => <Text>{params ? dateFormat(params) : "N/A"}</Text>,
    },
  ];

  return (
    <>
      <Col style={{ padding: "2rem" }}>
        <Row>
          <Col className="header-container">
            <Text className="heading">HSN Report</Text>
          </Col>
        </Row>
        <Row className="action-container">
          <Col className="action-sub-container">
            <SearchInput
              size={"large"}
              placeholder={"Search by HSN Code"}
              getLibraryApi={getHSNReportApi}
              width={"400px"}
              isLoading={isLoading}
              handleSearchedValue={handleSearchedValue}
            />

            <CustomSelect
              placeholder={"Date"}
              width={"150px"}
              options={options}
              handleChange={handleChange}
              value={dateFilter}
            />
            {dateFilter === "Custom" && (
              <DateRangePicker
                onChange={handleChangeRangePicker}
                format={"DD-MMM-YYYY"}
              />
            )}
            <Button
              type="primary"
              className="add_customer_btn"
              onClick={handleExportApi}
              disabled={isExporting}
              icon={isExporting ? <LoadingOutlined /> : <DownloadOutlined />}
            >
              <span>Export</span>
            </Button>
          </Col>
          <Col style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
            <Button
              type="primary"
              className="add_customer_btn"
              onClick={handleSyncReport}
              disabled={isSyncingReport}
              icon={isSyncingReport ? <LoadingOutlined /> : <SyncOutlined />}
            >
              <span>Sync Report</span>
            </Button>
          </Col>
        </Row>
        <Col>
          <CustomTableWithPagination
            className="order-list-table"
            tableDataSource={hsnData?.data?.results || []}
            tableColumns={columns}
            locale={{
              emptyText: isLoading ? (
                <TableSkeleton length={10} />
              ) : (
                <NoDataFound text={"No line of credit found!"} />
              ),
            }}
            scroll={{ x: "100%" }}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
            itemsPerPage={30}
            totalEntries={!isLoading && hsnData?.data?.pagination?.total_entries}
            isLoading={hsnData?.data?.results?.length && isLoading}
          />
        </Col>
      </Col>
    </>
  );
};

export default HSNReport;
